import {
  FormControlBlack,
  FormSelectBlack,
  InputGroupBlack,
  LabelBlack,
  LabelTextGrey,
} from "../pages/components/PageParams";
import { DateTimePickerBlack } from "../features/RadConnStyle";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import styled, { keyframes } from "styled-components";
import { Button } from "react-bootstrap";
import { ThaiDate } from "./ThaiDate";
import moment from "moment";
import ThreeDots from "react-loading-icons/dist/esm/components/three-dots";
import { FcDataBackup, FcDeleteDatabase, FcOk } from "react-icons/fc";
import axios from "axios";
import { HttpJsonHeader } from "../features/Environments";
import { AiFillCalendar } from "react-icons/ai";
import { FaFemale, FaMale } from "react-icons/fa";
import { StyleSheet } from "@react-pdf/renderer";
import { setReminder } from "../features/UserActions";
import { GetPatientAge } from "./Helper2";
// import DateTimePicker from 'react-datetime-picker';

export const FormAuto = (props) => {
  return (
    <Form
      id={props.formId}
      onSubmit={props.submit}
      ref={props?.refTo}
      className="formX1"
    >
      {props.items &&
        props.items.map((item) => {
          if (item.type === "text") {
            return (
              <InputGroupBlack key={item.oName}>
                <LabelBlack> {item.label}</LabelBlack>
                <FormControlBlack
                  aria-label={item.lable}
                  name={item.oName}
                  required={item.require}
                  defaultValue={item.defaultValue}
                  disabled={item?.disabled}
                  placeholder={"ระบุ" + item.label + " .."}
                  style={{ width: "100%" }}
                />
              </InputGroupBlack>
            );
          } else if (item.type === "date") {
            return (
              <InputGroupBlack key={item.oName}>
                <LabelBlack> {item.label}</LabelBlack>
                <FormControlBlack
                  type="date"
                  key={item.oName}
                  aria-label={item.lable}
                  name={item.oName}
                  required={item.require}
                  defaultValue={item.defaultValue}
                  locale="th"
                  language="th-th"
                  isClearable={true}
                  date-format="DD MMMM YYYY"
                  style={{ width: "100%" }}
                />
              </InputGroupBlack>
            );
          } else if (item.type === "select") {
            return (
              <InputGroupBlack>
                <LabelBlack> {item.label}</LabelBlack>
                <FormSelectBlack
                  aria-label="ตัวเลือก"
                  name={item.oName}
                  defaultValue={item.defaultValue}
                  rows={item.rows}
                  onChange={item?.onChange}
                />
              </InputGroupBlack>
            );
          } else if (item.type === "select2") {
            return (
              <InputGroupBlack>
                <LabelBlack> {item.label}</LabelBlack>
                <FormSelectBlack
                  aria-label="ตัวเลือก"
                  name={item.oName}
                  defaultValue={item.defaultValue}
                  value={item?.value}
                  rows={item.rows}
                  onChange={(e) => {
                    item?.setValue(e.target.value);
                  }}
                />
              </InputGroupBlack>
            );
            // }
          } else if (item.type === "checkbox")
            return (
              <InputGroupBlack key={item.oName}>
                <Form.Check
                  id={item.oName}
                  key={item.oName}
                  name={item.oName}
                  style={{ color: "#7cb6fe" }}
                  type="switch"
                  label={item.label}
                  defaultChecked={item?.defaultValue ?? false}
                />
              </InputGroupBlack>
            );
        })}
    </Form>
  );
};

export const FormAutoB = (props) => {
  return (
    <Form
      autoComplete="off"
      id={props.formId}
      ref={props.refTo && props.refTo}
      onSubmit={
        props.submit
          ? props.submit
          : (e) => {
              e.preventDefault();
            }
      }
      className="formX1"
    >
      {props.items &&
        props.items.map((item, i) => {
          let curValue = null;
          if (props.data) {
            curValue = props?.data[item.oName];
          }

          switch (item.type) {
            case "text":
              return (
                <InputGroupBlack key={item.oName}>
                  <LabelBlack> {item.label}</LabelBlack>
                  <FormControlBlack
                    type="text"
                    autoComplete="off"
                    key={item.oName}
                    aria-label={item?.label}
                    name={item.oName}
                    required={item.require}
                    //defaultValue={props.data ? props.data[item.oName] : ""}
                    //defaultValue={props.data && props?.data[item.oName]}
                    defaultValue={curValue ?? ""}
                    ref={item.ref}
                    disabled={item?.disabled}
                    onChange={item?.onChange}
                    placeholder={`กรอก ${item?.label ?? ""} ...`}
                    style={{ width: "100%" }}
                  />
                </InputGroupBlack>
              );

            case "password":
              return (
                <InputGroupBlack key={item.oName}>
                  <LabelBlack> {item.label}</LabelBlack>
                  <FormControlBlack
                    type="password"
                    autoComplete="new-password"
                    aria-label={item.label}
                    name={item.oName}
                    key={item.oName}
                    required={item.require}
                    // defaultValue={props.data && props?.data[item.oName]}
                    defaultValue={curValue ?? ""}
                    placeholder={`กรอก ${item?.label ?? ""} ...`}
                    style={{ width: "100%" }}
                  />
                </InputGroupBlack>
              );
            case "text_area":
              let def = props.data && props?.data[item.oName];
              return (
                <InputGroupBlack key={item.oName}>
                  <LabelBlack> {item.label && item.label}</LabelBlack>
                  <FormControlBlack
                    as="textarea"
                    aria-label={item.label}
                    name={item.oName}
                    key={item.oName}
                    required={item.require}
                    // defaultValue={def ? def : null}
                    defaultValue={curValue ?? null}
                    onChange={item.onChange}
                    placeholder={`กรอก ${item?.label ?? ""} ...`}
                    rows={item.textRows}
                    style={{ flex: 1, width: "100%" }}
                  />
                </InputGroupBlack>
              );

            // break;

            case "date":
              //let dateStr = props && props.data && props.data[item.oName];
              const [value, setValue] = item.state && item.state;

              return (
                <InputGroupBlack key={item.oName}>
                  <LabelBlack> {item.label}</LabelBlack>
                  <DateTimePickerBlack
                    name={item.oName}
                    value={value}
                    onChange={(e) => {
                      setValue(e);
                    }}
                    format="dd/MM/yyyy"
                    locale="th-th"
                    clearIcon={false}
                  />
                </InputGroupBlack>
              );

            case "datetime":
              //let dateStr = props && props.data && props.data[item.oName];
              const [dValue, setDValue] = item.oState;
              // console.log("dis State", item?.disabled);
              if (curValue) {
                setDValue(curValue);
              }
              return (
                <InputGroupBlack key={item.oName}>
                  <LabelBlack> {item.label}</LabelBlack>
                  <DateTimePickerBlack
                    name={item.oName}
                    ref={item.ref}
                    disableClock={true}
                    disableCalendar={item?.disabled}
                    disabled={item?.disabled}
                    //defaultValue={curValue ?? new Date()}
                    value={new Date(dValue) ?? new Date()}
                    onClick={item?.onClick}
                    onChange={item?.onChange}
                    onClicking={item?.onClicking}
                    calendarIcon={<AiFillCalendar color="#e9dc2d" />}
                    format="dd/MM/yyyy HH:mm"
                    locale="th-TH"
                    clearIcon={false}
                  />
                </InputGroupBlack>
              );

            case "select":
              return (
                <InputGroupBlack key={item.oName}>
                  <LabelBlack> {item.label}</LabelBlack>
                  <FormSelectBlack
                    aria-label="ตัวเลือก"
                    key={item.oName}
                    name={item.oName}
                    rows={item.rows}
                    defaultValue={props.data ? props.data[item.oName] : null}
                    onLoad={item?.onLoad}
                    onClick={item.onClick}
                    onChange={item.onChange}
                    style={{ background: "var(--button-background)" }}
                  />
                </InputGroupBlack>
              );

            case "label":
              return (
                <InputGroupBlack key={item.oName}>
                  <LabelBlack> {item.label}</LabelBlack>
                  <LabelTextGrey
                    style={{
                      flex: "1",
                      display: "flex",
                      textWrap: "balance",
                    }}
                  >
                    {props.data ? props.data[item.oName] : ""}
                  </LabelTextGrey>
                </InputGroupBlack>
              );

            case "find":
              return (
                <InputGroupBlack key={item.oName}>
                  <LabelBlack> {item.label} </LabelBlack>
                  <FinderBox>
                    <LabelBox>
                      <LabelTextGrey>
                        {props.data ? props.data[item.oName] : ""}
                      </LabelTextGrey>
                    </LabelBox>
                    <Button disabled={item?.disabled} onClick={item.click}>
                      ...
                    </Button>
                  </FinderBox>
                </InputGroupBlack>
              );

            case "find-text":
              return (
                <InputGroupBlack key={item.oName}>
                  <LabelBlack {...item.labelStyle}> {item.label} </LabelBlack>
                  <FinderBox>
                    <FormControlBlack
                      type="text"
                      autoComplete="off"
                      key={item.oName}
                      aria-label={item?.label}
                      name={item.oName}
                      required={item.require}
                      value={item?.defaultValue ?? ""}
                      ref={item.ref}
                      disabled={item?.disabled}
                      onChange={item?.onChange}
                      placeholder={"ระบุ" + item.label + " .."}
                      style={{ backgroundColor: "var(--input-bg)" }}
                    />
                    <span style={{ paddingInline: "5px" }}>
                      {CreateTooltip(
                        item?.tooltip ?? "ค้นหา",
                        <Button disabled={item?.disabled} onClick={item.click}>
                          {item?.buttonCaption ?? "..."}
                        </Button>,
                        "top"
                      )}
                    </span>
                    <span style={{ paddingInline: "1px" }}>
                      {CreateTooltip(
                        item.button2Tooltip ?? "ค้นหา",
                        <Button
                          disabled={item?.disabled}
                          onClick={item.button2Click}
                          hidden={!item.showButton2 ?? true}
                        >
                          {item?.button2Caption ?? ""}
                        </Button>
                      )}
                    </span>
                  </FinderBox>
                </InputGroupBlack>
              );

            case "checkbox":
              return (
                <InputGroupBlack key={item.oName}>
                  <Form.Check
                    id={item.oName}
                    key={item.oName}
                    name={item.oName}
                    style={{ color: "#7cb6fe" }}
                    type="switch"
                    label={item.label}
                    defaultChecked={
                      props.data && props.data[item.oName] === "y"
                        ? true
                        : false
                    }
                    onChange={(e) =>
                      (props.tmpCheckState[item.oName] = e.target.checked
                        ? "y"
                        : "n")
                    }
                  />
                </InputGroupBlack>
              );
            default:
              return false;
          } //*** end-case
        })}
    </Form>
  );
};

const FinderBox = styled.div`
  flex: 1;
  display: flex;
  border: 1px solid var(--button-border-color);
  border-radius: 5px;
`;
const LabelBox = styled.div`
  flex: 1;
  display: flex;
`;

export const TestImage = (URL) =>
  new Promise((resolve, reject) => {
    var tester = new Image();
    tester.onload = () => resolve();
    tester.onerror = () => reject();
    tester.src = URL;
  });

export const GetHeaderStyle = (wi, verAlign, fontFamily, fontSize) => {
  return {
    width: wi,
    background: "var(--table-header-back-color)",
    color: "var(--table-header-fore-color)",
    fontWeight: "lighter",
    // fontFamily: fontFamily ?? "prompt",
    fontFamily: "tahoma",
    textAlign: verAlign ?? "center",
    // fontSize: fontSize ?? "14px",
    fontSize: "14px",
    verticalAlign: "middle",
  };
};

export const getCellStyle = (
  hAlign,
  color,
  fontSize,
  fontFamily,
  border,
  paddingLeft
) => {
  return {
    border: "none",
    textAlign: hAlign ? hAlign : "left",
    color: color ? color : "var(--table-text-color)",
    fontSize: fontSize ? fontSize : "14px",
    fontFamily: fontFamily ?? "tahoma",
    // fontSize: "8px",
    // fontFamily: "tahoma",
    border: border ?? "none",
    paddingLeft: paddingLeft ?? "0",
  };
};

export const GetNormalStyle = (hAlign, textColor, border) =>
  getCellStyle(
    hAlign ? hAlign : "center",
    textColor ? textColor : "var(--table-text-color)", // "var(--tb-fore-row)",
    "14px",
    "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    border ? border : "1px solid var(--tb-border-color)",
    hAlign === "left" ? "10px" : "0"
  );

export const GetNormalNiramit = (hAlign, textColor, border) =>
  getCellStyle(
    hAlign ? hAlign : "center",
    "var(--tb-fore-row)",
    "18px",
    "niramit",
    border ? border : "1px solid var(--tb-border-color)"
  );

export const GetNormalPrompt = (hAlign, textColor, border) =>
  getCellStyle(
    hAlign ? hAlign : "center",
    textColor ? textColor : "var(--tb-fore-row)",
    "14px",
    "prompt",
    border ? border : "1px solid var(--tb-border-color)"
  );

export const FormatCurrency = (num) => {
  // return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return Number(num.toFixed(1)).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const FormatThaiDate = (date) => {
  return <ThaiDate dateValue={date} />;
};

export const FormatThaiCard = (value) => {
  // if(value!= null){
  return value.replace(
    /(\d{1})(\d{4})(\d{5})(\d{2})(\d{1}).*/g,
    "$1-$2-$3-$4-$5"
  );
  // }else{
  //   return "";
  // }
};

export const BlobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

export const GetDatePreriod = (style) => {
  let today = new Date();
  let firstDate = new Date();

  switch (style) {
    case "TODAY":
      return [today, today];
    case "YESTERDAY":
      firstDate = moment(new Date()).add(-1, "day");
      return [firstDate.toDate(), firstDate.toDate()];
    case "LAST7DAYS":
      firstDate = moment(new Date()).add(-7, "day");
      return [firstDate.toDate(), today];
    case "THISMONTH":
      firstDate = moment(
        new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0, 0),
        "DD/MM/YYYY"
      );
      return [firstDate.toDate(), today];
    case "LAST3M":
      firstDate = moment(
        new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0, 0),
        "DD/MM/YYYY"
      ).add(-3, "month");
      return [firstDate.toDate(), today];
    case "THISYEAR":
      return [new Date(), new Date()];
    default:
      return [new Date(), new Date()];
  }
};

export const EnumMessageType = {
  OK: 1,
  ERROR: 2,
  WARNING: 3,
};

export const EnumStudySeq = {
  APPOINT: 1,
  SCAN_COMPLETE: 2,
  UPLOADING: 3,
  UPLOADED: 4,
  RESULT_REQUEST: 5,
  INFORM_ADM: 6,
  INFORM_RAD: 7,
  RAD_REJECTED: 8,
  RAD_ACCEPTED: 9,
  PAT_EDITED: 10,
  DIAG_DRAFT: 11,
  DIAG_PRELIMINARY: 12,
  DIAG_COMPLETE: 13,
  PRINT: 14,
  DIAG_VIEWED: 15,
  DIAG_EDITED: 16,
  FINAL: 17,
  REMOVE: 18,
  RAD_INFORMS: 19,
  PHY_INFORMS: 20,
  IMPORT: 21,
  OLD_STUDY: 22,
};

export const EnumStudyID = {
  APPOINT: 1,
  SCAN_COMPLETE: 2,
  UPLOADING: 3,
  UPLOADED: 4,
  RESULT_REQUEST: 5,
  INFORM_ADM: 6,
  INFORM_RAD: 7,
  RAD_REJECTED: 8,
  RAD_ACCEPTED: 9,
  PAT_EDITED: 10,
  DIAG_DRAFT: 11,
  DIAG_PRELIMINARY: 12,
  DIAG_COMPLETE: 13,
  PRINT: 14,
  DIAG_VIEWED: 15,
  DIAG_EDITED: 16,
  FINAL: 17,
  REMOVE: 18,
  RAD_INFORMS: 19,
  PHY_INFORMS: 20,
  IMPORT: 21,
  OLD_STUDY: 22,
};

export const EnumReplyButtonStyle = {
  RADI_CONFIRM_STUDY: 1,
  ADMIN_ACCEPTED_RESULT: 2,
};

export const EnumMessageFor = {
  RADIOLOGIST: 1,
  ADMIN: 2,
};

export const GetImageStduyStatus = (props) => {
  // console.log(id);
  // console.log(EnumStudyID.APPOINT, id.id);
  // if({id}===8){
  //   console.log("It is 8..")
  // }

  switch (props.id) {
    case EnumStudyID.APPOINT:
      return imageState(
        "Schedule",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "var(--sta-schedule)"
      );
    case EnumStudyID.SCAN_COMPLETE:
      return imageState(
        "รอส่งอ่าน",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "var(-sta-wait-sent)"
      );
    case EnumStudyID.UPLOADING:
      return imageState(
        "กำลัง Upload",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "var(--sta-uploading)"
      );
    case EnumStudyID.UPLOADED:
      return imageState(
        "Upload แล้ว",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "var(--sta-uploaded)"
      );
    case EnumStudyID.RESULT_REQUEST:
      return imageState(
        "ส่งอ่านแล้ว",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "var(--sta-sent-radi)"
      );
    case EnumStudyID.INFORM_ADM:
      return imageState(
        "แจ้งผู้ดูแลแล้ว",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "#f5f0f0"
      );
    case EnumStudyID.INFORM_RAD:
      return imageState(
        "แจ้งรังสีแพทย์",
        "#f8f078",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "var(--button-text-color)"
      );
    case EnumStudyID.RAD_REJECTED:
      return imageState(
        "Rejected",
        "transparent",
        "transparent",
        "var(--button-background)",
        "var(--button-background)",
        "var(--button-background)",
        "var(--sta-radi-reject)"
      );
    case EnumStudyID.RAD_ACCEPTED:
      return imageState(
        "Accepted",
        "#fef3c7",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "var(--button-text-color)"
      );
    case EnumStudyID.DIAG_DRAFT:
      return imageState(
        "DRAFT",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "var(--sta-draft)"
      );
    case EnumStudyID.DIAG_PRELIMINARY:
      return imageState(
        "Preliminary",
        "#aff5a6",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "var(--button-text-color)"
      );
    case EnumStudyID.DIAG_COMPLETE:
      return imageState(
        "Complete",
        "#0cb615",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "#ffffff"
      );
    case EnumStudyID.DIAG_VIEWED:
      return imageState(
        "เปิดดูผล",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "#06f33a"
      );
    case EnumStudyID.DIAG_EDITED:
      return imageState(
        "Complete(ed)",
        "#0cb615",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "#edfa78"
      );
    case EnumStudyID.PAT_EDITED:
      return imageState(
        "แก้ไขข้อมูลคนไข้",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "var(--sta-pati-edit)"
      );
    case EnumStudyID.PRINT:
      return imageState(
        "พิมพ์ผล",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "#5e5a5a"
      );
    case EnumStudyID.FINAL:
      return imageState(
        "สมบูรณ์",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "#071197"
      );
    case EnumStudyID.REMOVE:
      return imageState(
        "รายการถูกลบ",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "#f5f0f0"
      );
    case EnumStudyID.RAD_INFORMS:
      return imageState(
        "แพทย์แจ้งปัญหา",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "#f5f0f0"
      );
    case EnumStudyID.PHY_INFORMS:
      return imageState(
        "เจ้าของไข้แจ้งปัญหา",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "#f5f0f0"
      );
    case EnumStudyID.IMPORT:
      return imageState(
        "นำเข้า",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "#f5f0f0"
      );
    case EnumStudyID.OLD_STUDY:
      return imageState(
        "ภาพเก่า",
        "#ransparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "var(--button-text-color)"
      );
    default:
      return imageState(
        "รอส่งอ่าน",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "#4ac2fa"
      );
  }
};

const imageState = (text, bg, borderColor, c1, c2, c3, textColor) => {
  return (
    <Circle bgcolor={bg} borderColor={borderColor} c1={c1} c2={c2} c3={c3}>
      {/* <DivInner bg={bg} c1={c1} c2={c2} c3={c3} /> */}
      <DivText textColor={textColor}>{text}</DivText>
    </Circle>
  );
};

const Circle = styled.div`
  background-color: ${(p) => p.bgcolor};
  line-height: 40px;
  border-radius: 16px;
  // animation
  /* animation-name: ${(p) => litting(p.c1, p.c2, p.c3)};
  animation-duration: 2.5s; //1.5s;
  animation-iteration-count: infinite; */

  padding-inline: 2px;
  /* border: 1px solid var(--button-border-color); */

  flex: 1;
`;

const litting = (a, b, c) => keyframes`
  0% {background-color:${a}} 
  60% {background-color:${b}}
  80% {background-color:${c}}   
`;

export const GetEnumValue = (obj, value) => {
  return Object.keys(obj).find((key) => obj[key] == value);
};

const DivText = styled.div`
  color: ${(p) => p.textColor};
  align-items: center;
  flex: 1;
  line-height: 40px;
`;

export const getRandomBase64Text = (numOfText) => {
  function randomInt() {
    const text =
      "ABCDEFGHIJKLMNOPQRSTYVWXYZabcdefghijklmnopqrstuvwxyz1234567890+/";
    let rndNum = Math.floor(Math.random() * 62);
    return text[rndNum];
  }

  let tx = "";
  for (let i = 0; i < numOfText; i++) {
    tx += randomInt();
  }

  return tx;
};

export const DicomStatusHeader = (x, row, text, onClicking) => {
  let numStatus = row?.upload_status;
  console.log(numStatus);

  if (numStatus == 0) {
    return (
      <div style={dicomHeaderStyle("var(--uploaded-icon-fore)")}>
        <ThreeDots width={30} height={10} />
        Receiving..
      </div>
    );
  } else if (numStatus == 1)
    return (
      <div style={dicomHeaderStyle("var(--uploaded-icon-fore)")}>
        <ThreeDots width={30} height={10} />
        Uploading..
        {row?.num_of_study_related_instances ? (
          <div style={{ color: "var(--uploaded-qty-fore)" }}>
            <span style={{ color: "var(--upload-bracket)" }}>{"("}</span>
            {toDecimal(row.num_of_study_related_instances)}
            <span style={{ color: "var(--upload-bracket)" }}>{" imgs.)"}</span>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  else if (numStatus == 2)
    //Uploaded
    return (
      // <div
      //   style={dicomHeaderStyle("var(--uploaded-icon-fore)")}
      //   onClick={() => onClicking && onClicking(row, numStatus)}
      // >
      //   <FcOk color="red" style={{ height: "20px", width: "20px" }} />
      //   Download
      //   {row?.num_of_study_related_instances ? (
      //     <div style={{ color: "var(--uploaded-qty-fore)" }}>
      //       <span style={{ color: "var(--upload-bracket)" }}>{"("}</span>
      //       {toDecimal(row.num_of_study_related_instances)}
      //       <span style={{ color: "var(--upload-bracket)" }}>{" imgs.)"}</span>
      //     </div>
      //   ) : (
      //     <></>
      //   )}
      // </div>
      <DownloadBox>
        <button
          class="file-download-btn"
          title="Download"
          onClick={() => onClicking && onClicking(row, numStatus)}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M8 2 L8 11 M4 8 L8 12 L12 8 M2 14 L14 14" />
          </svg>
        </button>
        {toDecimal(row.num_of_study_related_instances)} files.
      </DownloadBox>
    );
  // 4 == wait reupload image */
  else if (numStatus == 4) {
    return (
      // <div style={dicomHeaderStyle("#affab3")}>
      <div
        style={dicomHeaderStyle("#ddda08")}
        onClick={() => onClicking && onClicking(row, numStatus)}
      >
        <FcDataBackup color="red" style={{ height: "20px", width: "20px" }} />
        แจ้งขอภาพ
        {/* {row?.num_of_study_related_instances ? (
          <div style={{ color: "#f7f2f1" }}>
            <span style={{ color: "#5b5e5b" }}>{"("}</span>
            {toDecimal(row.num_of_study_related_instances)}
            <span style={{ color: "#7b7a7e" }}>{" imgs.)"}</span>
          </div>
        ) : (
          <></>
        )} */}
      </div>
    );
  } else {
    return (
      // <div
      //   style={dicomHeaderStyle("var(--deleted-icon-fore)")}
      //   onClick={() => onClicking && onClicking(row, numStatus)}
      // >
      //   <FcDeleteDatabase
      //     color="#121212"
      //     style={{ height: "20px", width: "20px", marginInline: "2px" }}
      //   />
      //   Deleted
      // </div>
      <button
        class="file-deleted-btn"
        title="Deleted"
        disabled
        onClick={() => onClicking && onClicking(row, numStatus)}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
        >
          <line x1="5" y1="5" x2="13" y2="13" />
          <line x1="13" y1="5" x2="5" y2="13" />
        </svg>
      </button>
    );
  }
};

const dicomHeaderStyle = (color1) => {
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontSize: "10px",
    color: color1 ? color1 : "#83857e",
  };
};

export const CreateTooltip = (tooltip, obj, position) => (
  <OverlayTrigger
    style={{ flex: "1", justifyContent: "center" }}
    placement={position ? position : "top"}
    overlay={<Tooltip style={{ color: "#ffff00" }}>{tooltip}</Tooltip>}
  >
    {obj}
  </OverlayTrigger>
);

export const toDecimal = (value, digit) => {
  if (!value) return "0";
  return Number(value).toLocaleString("th-TH", {
    style: "decimal",
    minimumFractionDigits: digit ?? 0,
  });
};

export const PostJson = async (api, params) =>
  new Promise((resolve, reject) => {
    axios
      .post(process.env.REACT_APP_API + api, params, HttpJsonHeader)
      .then((ret) => {
        resolve(JSON.parse(ret?.data ?? []));
      })
      .catch((err) => {
        // reject({ show: true, message: err.message, type: "error" })
        console.log("return from api " + api, err?.message);
        resolve(null);
      });
  });

export const Post = async (api, params) =>
  new Promise((resolve, reject) => {
    axios
      .post(process.env.REACT_APP_API + api, params, HttpJsonHeader)
      .then((ret) => {
        resolve(ret?.data);
      })
      .catch((err) => {
        console.log("return from api " + api, err);
        resolve(null);

        // reject({ show: true, message: err.message, type: "error" })
      });
  });

export const FileUploadStatus = {
  Receiving: 0,
  Uploading: 1,
  Uploaded: 2,
  Deleted: 3,
  WaitReUpload: 4,
};

export const ConvertJson2Date = (curdate) => {
  return new Date(curdate).toJSON().slice(0, 10).split("-").reverse().join("/");
};

export const ConvertMinutesToTimeRemain = (numToCal, isResultOk) => {
  if (isResultOk) {
    return <div style={{ color: "#f47709" }}>--</div>;
  }
  if (numToCal > 0) {
    let hh = Math.floor(numToCal / 60);
    let mm = numToCal % 60;
    let ret = "";
    if (hh > 0) {
      ret = hh + " hr. ";
    }
    if (mm > 0) {
      ret += mm + " min.";
    }
    return <div style={{ color: "var(--date-remaining)" }}>{ret}</div>;
  }
  // else {
  //   return <div style={{ color: "#f47709" }}>--</div>;
  //   // เกินกำหนด
  // }
};

export const getFormatAge = (cell) => {
  return GetPatientAge(cell);
};
export const Gender = (cell, row) => {
  // return `${cell === "M" ? <AiFillClockCircle /> : "หญิง"}`;

  // return cell === "M" ? (
  //   // <FaMale size={20} color="#18d307" />
  //   {ชาย}
  // ) : (
  //   // <FaFemale size={20} color="#f523c0" />
  //   {หญิง}
  // );

  return cell === "M" ? "ชาย" : "หญิง";
};

export const UrgentType = (cell, row) => {
  let cc = "#121212";
  if (row?.is_study_old == "y") {
    return <></>;
  }
  switch (row?.urgenttypeid) {
    case 1: //Normal
      cc = "var(--normal-fore)";
      break;
    case 2: // emergency
      cc = "var(--emergency-fore)";
      break;
    case 3: // Urgency
      cc = "var(--urgency-fore)";
      break;
    case 4: // fast-track
      cc = "var(--fasttrack-fore)";
      break;
    default:
      break;
  }
  return <div style={{ color: cc }}>{row?.urgenttype_name}</div>;
};

export const ClearOldSession = () => {
  sessionStorage.removeItem("radconn_pacs_study_id");
  sessionStorage.removeItem("radconn_staff_id");
  sessionStorage.removeItem("radconn_param_type");
  sessionStorage.removeItem("message_id");
};

export const DOCU_MARGIN = { left: 40, top: 40, bottom: 60, right: 20 };

const thSarabun = "ThSarabun";
const thSarabunBold = "ThSarabunBold";
const courier = "Courier";
const courierBold = "Courier";

export const invoiceDocuStyles = StyleSheet.create({
  document: { flex: 1 },
  page: {
    fontFamily: thSarabun,
    flexDirection: "column",
    borderWidth: 1,
    paddingTop: DOCU_MARGIN.top,
    paddingLeft: DOCU_MARGIN.left,
    paddingRight: DOCU_MARGIN.right,
    paddingBottom: DOCU_MARGIN.bottom,
    fontSize: 14,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    // marginHorizontal: 10,
    alignItems: "center",
    paddingVertical: 10,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: "grey",
    color: "black",
    fontFamily: thSarabun,
  },
  headerLogo: {
    flex: 0.2,
    border: 1,
    borderColor: "#a1eeb8",
    padding: 5,
    margin: 10,
    textAlign: "center",
    borderRadius: 10,
  },
});

export const FormatThaiCard3 = (value) => {
  let test = "";
  if (!value) return "";
  let numData = value.replace(/\D+/, "");
  numData = numData.replace(/\D+/, "");

  while (numData.match(/\D+/) != null) {
    numData = numData.replace(/\D+/, "");
    //console.log("not null");
  }

  if (numData.length > 13) {
    numData = numData.substr(0, 13);
  }

  if (numData.length <= 4) {
    test = numData.replace(/(\d{1})/, "$1-");
  } else if (numData.length <= 9) {
    test = numData.replace(/(\d{1})(\d{4})/, "$1-$2-");
  } else if (numData.length <= 11) {
    test = numData.replace(/(\d{1})(\d{4})(\d{5})/, "$1-$2-$3-");
  } else if (numData.length <= 13) {
    test = numData.replace(/(\d{1})(\d{4})(\d{5})(\d{2})/, "$1-$2-$3-$4-");
  } else {
    test = numData;
  }

  return test;
};

export const AlertError = (message, dispatch) => {
  dispatch(
    setReminder({
      show: true,
      message: message ? message : "เกิดปัญหาในการเรียกข้อมูล",
      type: "error",
    })
  );
};

export const AlertOK = (message, dispatch) => {
  dispatch(
    setReminder({
      show: true,
      message: message ? message : "OK",
      type: "success",
    })
  );
};

export const CustomTextFilter = {
  placeholder: "...",
};

export function AddDays(date, days) {
  var result = moment(new Date()).add(days, "day").toDate();
  return result;
}

/**
 * Convert dot-string format to object
 * @param {*} dotString like "aaa.bbb"
 * @param {*} value
 * @returns '{aaa: {bbb: value}}'
 */
export const DotStringToObject = (dotString, value) => {
  let keys = dotString.split(".");
  let obj = {};
  let temp = obj;

  for (let i = 0; i < keys.length - 1; i++) {
    temp[keys[i]] = {};
    temp = temp[keys[i]];
  }

  temp[keys[keys.length - 1]] = value;
  return obj;
};

export const DeepMergeObject = (target, source) => {
  for (let key in source) {
    if (
      source[key] &&
      typeof source[key] === "object" &&
      !Array.isArray(source[key])
    ) {
      if (!target[key]) target[key] = {};
      DeepMergeObject(target[key], source[key]);
    } else {
      target[key] = source[key];
    }
  }
  return target;
};

/**
 *
 * @param {*} obj  Array of selector [aaa:{bbb:1, ccc:2}]
 * @param {*} path เช่น "aaa.ccc"
 * @param {*} defaultValue
 * @returns
 */

export function GetDeepValue(obj, path, defaultValue) {
  return (
    path
      .split(".")
      .reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
        obj
      ) ?? defaultValue
  );
}

export const MysqlDateCV = (mysql_string) => {
  var t;
  var result;
  if (typeof mysql_string === "string") {
    t = mysql_string.split(/[- : T]/);
    result = new Date(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0);
  } else {
    result = mysql_string;
  }
  return result;
};

export const GetThaiFormatDate = (mysqlTDate) => {
  return new Date(MysqlDateCV(mysqlTDate)).toLocaleDateString("th-TH", {
    timeZone: "Asia/Ho_Chi_Minh",
  });
};

export const GetThaiFormatDateTime = (mysqlTDate) => {
  let date = new Date(MysqlDateCV(mysqlTDate));
  const option = { timeZone: "Asia/Ho_Chi_Minh" };
  const locale = "th-TH";
  return (
    date.toLocaleDateString(locale, option) +
    " " +
    date.toLocaleTimeString(locale, option).substring(0, 5)
  );
};

export const GetShortDateNum = (obj) => {
  return new Date(MysqlDateCV(obj) - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .slice(2, 10)
    .replace(/-/g, "");
};

export const GetThaiZoneDate = (obj) => {
  return new Date(MysqlDateCV(obj) - new Date().getTimezoneOffset() * 60000);
};

export const IsEmptyObject = (obj) => {
  return JSON.stringify(obj) === "{}";
};

export const IsEmptyArray = (obj) => {
  return JSON.stringify(obj) === "[]";
};

export const XButton = styled.div`
  display: flex;
  background: ${(props) => {
    return props?.background || "var(--button-background )";
  }};
  padding-inline: 15px;
  padding-block: 10px;
  justify-content: center;
  border-radius: 12px;
  color: var(--button-text-color);
  margin-inline: 1px;
  border: 1px solid var(--button-border-color);
  cursor: pointer;
  :hover {
    background-color: var(--button-background-hover);
    transition: 300ms;
    color: var(--button-text-color-hover);
    border-color: var(--button-border-color-hover);
  }
`;

export const ThaicardToNumber = (value) => {
  if (!value) return "";
  return value.replace(/\D/g, "");
};

export const CheckMessageError = (ret) => {
  if (ret?.message === "Error") {
    return ret?.Data;
  }
  return null;
};

export const IsNullOrEmptyObject = (obj) => {
  if (IsEmptyObject(obj)) return true;
  if (obj === null) return true;
  if (obj === undefined) return true;
  if (obj === "undefined") return true;
  return false;
};

export const defaultHeaderIconStyle = {
  height: "30px",
  width: "30px",
  marginInline: "5px",
};

export const defaultSpanText = {};

export const defaultHeaderContainerStyle = {
  paddingBlock: "5px",
};

export function formatDateTimeYYYYMMDDHHMMSS(date) {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  return `${year}${month}${day}${hours}${minutes}${seconds}`;
}

const DownloadBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #255e04;
`;
